import characters from "./characters";
import { Entity, Game, GameFlow, SectionType } from "./types";

export const flow: GameFlow = [

    {
        type: SectionType.INTERLUDE,
        screens: [
            {text: {t: "Humena humena..."}, image: 'https://media0.giphy.com/media/3otPoL98SINy7AIBig/200w.gif?cid=6c09b952dmdj8jzvunwswdc28f5ip3mrlqyjp7mgg3sabhy8&ep=v1_gifs_search&rid=200w.gif&ct=g'},
            {text: {t: "Oh sorry, didn't see you there!"}},
            {text: {t: "Let me tell you a tale."}},
            {text: {t: "It's one that you won't soon forget."}},
            {text: {t: " It was a dark and stormy night..."}},
            {
                image: 'https://64.media.tumblr.com/96bbfb0b0af9a6118d0049f63e25cf46/tumblr_oxsf7locdn1wzypxlo1_500.gif', 
                maxDuration: 2000
            },
            {
                npcDialog: {
                    person: characters.BigEd,
                    dialog: "Well... i reckon we're fucked"
                },
                image: 'https://64.media.tumblr.com/96bbfb0b0af9a6118d0049f63e25cf46/tumblr_oxsf7locdn1wzypxlo1_500.gif', 
                maxDuration: 2000
            },
            {
                npcDialog: {
                    person: characters.BigEd,
                    dialog: "Better get my dick and skee-dadle."
                },
                image: 'https://64.media.tumblr.com/96bbfb0b0af9a6118d0049f63e25cf46/tumblr_oxsf7locdn1wzypxlo1_500.gif', 
                maxDuration: 2000
            },
            {
                image: 'https://media4.giphy.com/media/h6x0ROdzJy4TKyUu1b/giphy.gif?cid=6c09b952esk0doy8miswfytlvmjvrza5h8mtml1zyna87w8v&ep=v1_gifs_search&rid=giphy.gif&ct=g',
                uid: 'splash into water from boat'
            }, 
            {
                image: 'https://i.pinimg.com/originals/83/b7/ac/83b7acd7cdb46af483af0b543043b232.gif'
            },
            {
                npcDialog: {
                    person: characters.BigEd,
                    dialog: "Well, i recon everyone's just about dead."
                },
                image: 'https://i.pinimg.com/originals/83/b7/ac/83b7acd7cdb46af483af0b543043b232.gif'
            },
            {
                npcDialog: {
                    person: characters.Mandelbrot,
                    dialog: "...I'm not dead...."
                },
                image: 'https://i.pinimg.com/originals/83/b7/ac/83b7acd7cdb46af483af0b543043b232.gif'
            },
            {
                npcDialog: {
                    person: characters.Mandelbrot,
                    dialog: "I am very much.... ALIVE!"
                },
                image: 'https://i.pinimg.com/originals/83/b7/ac/83b7acd7cdb46af483af0b543043b232.gif'
            },
            {
                image: characters.Mandelbrot.image,
                userOptionQuestion: {
                    prompt: 'What would you like to do?',
                    options: [
                        {text: 'Punch him', navToFrameUid: 'splash into water from boat'},
                        {text: 'Kiss him', navToFrameUid: 'flame of of eternal love'},
                        {text: 'Hold him dearly like his mudda' , navToFrameUid: 'you make mandelbrot vomit all over in the water'}
                    ]
                }
            },
            {
                image: "https://viralviralvideos.com/wp-content/uploads/GIF/2015/04/Super-gross-throws-up-GIF.gif",
                uid: "you make mandelbrot vomit all over in the water"
            },
            {
                image: "https://viralviralvideos.com/wp-content/uploads/GIF/2015/04/Super-gross-throws-up-GIF.gif",
                npcDialog: {
                    person: characters.Lawyer,
                    dialog: "Whoa there sport! Looks like you're gonna need a Lawyer!"
                }
            },
            {
                image: "https://viralviralvideos.com/wp-content/uploads/GIF/2015/04/Super-gross-throws-up-GIF.gif",
                npcDialog: {
                    person: characters.Lawyer,
                    dialog: "I got your ASS covered bro, TRUST me."
                }
            },
            {
                image: "https://geographical.co.uk/wp-content/uploads/shutterstock_1640168446-2-copy.jpg",
                userOptionQuestion: {
                    prompt: 'What would you like to do?',
                    options: [
                        {text: 'Hadle zone', navToFrameUid: 'todo'},
                        {text: 'Try to seduce lawyer', navToFrameUid: 'todo'},
                        {text: 'Sperm whale', navToFrameUid: 'todo'},
                        {text: 'Hawaii', navToFrameUid: 'hawaii intro'}
                    ]
                }
            },
            {
                image: "https://media.tenor.com/TPvdyjH6VmYAAAAM/heart-fire.gif",
                text: {t: "CONGRATULATIONS, YOU'RE GETTING MARRIED. THE FLAME OF ETERNAL LOVE HAS FOUND A HOME FOREVER IN YOUR HEART"},
                uid: "flame of of eternal love"
            }
        ]
    }, 
    // Hawaii Intro
    {type: SectionType.INTERLUDE,
        screens: [
            {image: "https://media2.giphy.com/media/v1.Y2lkPTZjMDliOTUyem9tdDNvYzExZmI2M2hmd3VqbHZmY3BlNDZvMnpuZmp0ZTRhMTRyYyZlcD12MV9naWZzX3NlYXJjaCZjdD1n/B2t72BEzuW3ywwbWiA/200.gif", uid: 'hawaii intro'},
            {image: "https://media2.giphy.com/media/v1.Y2lkPTZjMDliOTUyem9tdDNvYzExZmI2M2hmd3VqbHZmY3BlNDZvMnpuZmp0ZTRhMTRyYyZlcD12MV9naWZzX3NlYXJjaCZjdD1n/B2t72BEzuW3ywwbWiA/200.gif",
                npcDialog: {
                    person: characters.HawaiianShirtGuy,
                    dialog: "What's up hommie? How's it hangin?"
                },
                userOptionQuestion: {
                    prompt: 'What would you like to do?',
                    options: [
                        {text: '"Not much, how about you?"', navToFrameUid: 'not much response'},
                        {text: 'Kiss the guy, why not', navToFrameUid: 'kiss hawaiian shirt guy response'},
                        {text: 'Cry like you deserve it' , navToFrameUid: 'hawaii crying response'}
                    ]
                }
            },

            // Not much response 
            {
                image: "https://media2.giphy.com/media/v1.Y2lkPTZjMDliOTUyem9tdDNvYzExZmI2M2hmd3VqbHZmY3BlNDZvMnpuZmp0ZTRhMTRyYyZlcD12MV9naWZzX3NlYXJjaCZjdD1n/B2t72BEzuW3ywwbWiA/200.gif",
                npcDialog: {
                    person: characters.HawaiianShirtGuy,
                    dialog: "Why you gotta be boring like that hommie? I'm not interested in boring people hommie."
                },
                uid: 'not much response'
            },
            {
                image: characters.HawaiianShirtGuy.image,
                userOptionQuestion: {
                    prompt: 'What would you like to do?',
                    options: [
                        {text: 'Get into a physical altercation', navToFrameUid: 'todo'},
                        {text: 'Ask him why he\'s so afraid of intimacy', navToFrameUid: 'todo'}
                    ]
                },
            },

            // Kiss the guy response 
            {
                image: "https://media2.giphy.com/media/v1.Y2lkPTZjMDliOTUyem9tdDNvYzExZmI2M2hmd3VqbHZmY3BlNDZvMnpuZmp0ZTRhMTRyYyZlcD12MV9naWZzX3NlYXJjaCZjdD1n/B2t72BEzuW3ywwbWiA/200.gif",
                npcDialog: {
                    person: characters.HawaiianShirtGuy,
                    dialog: "Damn hommie, that was not bad. Common, I wanna introduce you to my folks."
                },
                uid: 'kiss hawaiian shirt guy response'
            },
            // TODO: would be nice to have a shorthand for overriding the LOCATION of a scene.... but otherwise allowing a scene to unfold in the same location.
            {
                image: characters.HawaiianShirtGuy.image,
                userOptionQuestion: {
                    prompt: 'What would you like to do?',
                    options: [
                        {text: 'Sure, why not', navToFrameUid: 'todo'},
                        {text: 'No way, I\'m not interested', navToFrameUid: 'todo'},
                        {text: 'I\'m not sure, why would you want to do that?', navToFrameUid: 'todo'}
                    ]
                },
            }
        ]

    },
    // Hawaii crying path 
    {type: SectionType.INTERLUDE,
        screens: [
            {image: "https://media2.giphy.com/media/v1.Y2lkPTZjMDliOTUyem9tdDNvYzExZmI2M2hmd3VqbHZmY3BlNDZvMnpuZmp0ZTRhMTRyYyZlcD12MV9naWZzX3NlYXJjaCZjdD1n/B2t72BEzuW3ywwbWiA/200.gif",
                npcDialog: {
                    person: characters.HawaiianShirtGuy,
                    dialog: "Aw hell, you're a mess. Cmon, let me get you a drink."
                },
                uid: 'hawaii crying response'
            },
            {
                image: "https://i0.wp.com/www.calisqueeze.com/wp-content/uploads/2022/05/Blog-Support-3.jpg?w=2360&quality=85&strip=color&ssl=1",
                npcDialog: {
                    person: characters.HawaiianShirtGuy,
                    dialog: "These are my guys, Chud, Wax, and Griselda"
                }
            },
            {
                image: "https://i0.wp.com/www.calisqueeze.com/wp-content/uploads/2022/05/Blog-Support-3.jpg?w=2360&quality=85&strip=color&ssl=1",
                npcDialog: {
                    person: characters.Chud,
                    dialog: "Sup dawg, Chud. Hear you crying?"
                }
            },
            {
                image: "https://i0.wp.com/www.calisqueeze.com/wp-content/uploads/2022/05/Blog-Support-3.jpg?w=2360&quality=85&strip=color&ssl=1",
                npcDialog: {
                    person: characters.Wax,
                    dialog: "Don't sweat it boss, I'm Wax. You're gonna be fine."
                }
            },
            {
                image: "https://i0.wp.com/www.calisqueeze.com/wp-content/uploads/2022/05/Blog-Support-3.jpg?w=2360&quality=85&strip=color&ssl=1",
                npcDialog: {
                    person: characters.Griselda,
                    dialog: "Griselda. Don't listen to these loosers, they're high out of their minds on PCP & paint thinners."
                }
            },
            {
                image: "https://i0.wp.com/www.calisqueeze.com/wp-content/uploads/2022/05/Blog-Support-3.jpg?w=2360&quality=85&strip=color&ssl=1",
                userOptionQuestion: {
                    prompt: 'What would you like to do?',
                    options: [
                        {text: 'Ask to marry Chud', navToFrameUid: 'todo'},
                        {text: 'Ask to marry Wax', navToFrameUid: 'todo'},
                        {text: 'Ask to marry Griselda', navToFrameUid: 'todo'},
                        {text: 'Suck your thumb', navToFrameUid: 'todo'}
                    ]
                }
            }
        ]
    }

]

export const nocturnalUndertones: Game = {
    name: 'nocturnal undertones',
    link: 'nocturnal_undertones',
    gameFlow: flow
}